import compose from 'recompose/compose';
import Customer from 'models/Customer';
import KioskLog from 'models/KioskLog';
import PropTypes from 'prop-types';
import toJS from 'shared/components/toJS';
import config from 'shared/config';
import React, { Component } from 'react';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { actions as brandInfoActions } from 'redux/domain/BrandInfo';
import { actions as navBarActions } from 'redux/domain/NavBar';
import { actions as storeLocationActions } from 'redux/domain/StoreLocation';
import { actions as userActions } from 'redux/domain/User';
import { actions as cartActions } from 'redux/domain/Cart';
import { cancelRequest, getCancelTokenSource } from 'api/Helpers';
import NavBar from '../components/NavBar';
import withRouter from '../../../shared/utils/WithRouter';

class NavBarContainer extends Component {
	constructor() {
		super();
		this.state = {
			// controls login overlay visibility
			showLogin: false,
			showRegistration: false,
			showEmailCart: false,
		};
		this.closeEmailCart = this.closeEmailCart.bind(this);
		this.openEmailCart = this.openEmailCart.bind(this);
		this.closeLogin = this.closeLogin.bind(this);
		this.openLogin = this.openLogin.bind(this);
		this.closeRegistration = this.closeRegistration.bind(this);
		this.openRegistration = this.openRegistration.bind(this);
		this.emailCartOpenLogin = this.emailCartOpenLogin.bind(this);
		this.logout = this.logout.bind(this);
		this.cancelTokenSource = getCancelTokenSource();
	}

	componentDidMount() {
		this.getBrandInfoAsync();
	}

	componentWillReceiveProps() {
		if (config.SingleSignOn.ShowEmailCart === true) {
			this.state.showEmailCart = true;
			config.SingleSignOn.ShowEmailCart = false;
			this.props.router.navigate('/category');
		}
	}

	componentWillUnmount() {
		const { closeMainDrawer, closeCartDrawer } = this.props;
		closeMainDrawer();
		closeCartDrawer();

		cancelRequest(this.cancelTokenSource);
	}

	/**
	 * Get the settings that clients use to customize the kiosk
	 */
	getBrandInfoAsync() {
		const { getBrandInfo } = this.props;
		try {
			getBrandInfo();
		} catch (error) {
			const log = new KioskLog(
				error,
				'Error file location: features/NavBar/containers/NavBarContainer',
			);
			log.postMessage();
		}
	}

	closeEmailCart() {
		this.props.clearEmailCartMessages();
		this.setState({ showEmailCart: false });
	}

	openEmailCart() {
		this.setState({ showEmailCart: true });
	}

	closeLogin() {
		this.setState({ showLogin: false });
	}

	openLogin() {
		if (config.SingleSignOn.STORISSingleSignOnEnabled) {
			window.location = `${
				config.ESTORIS_BASE_PATH
			}/STORISAuthentication/Login?returnUrl=/Kiosk/Welcome`;
		} else {
			this.setState({ showLogin: true });
		}
	}

	emailCartOpenLogin() {
		if (config.SingleSignOn.STORISSingleSignOnEnabled) {
			window.location = `${
				config.ESTORIS_BASE_PATH
			}/STORISAuthentication/Login?returnUrl=/Kiosk/Welcome?EmailCart`;
		} else {
			this.setState({ showLogin: true });
		}
	}

	closeRegistration() {
		this.setState({ showRegistration: false });
	}

	openRegistration() {
		if (config.SingleSignOn.STORISSingleSignOnEnabled) {
			window.location = `${
				config.ESTORIS_BASE_PATH
			}/STORISAuthentication/Login?returnUrl=/Kiosk/Welcome`;
		} else {
			this.setState({ showRegistration: true });
		}
	}

	logout() {
		this.props.logout();
		this.props.getGuestCustomer();
	}

	render() {
		const {
			brandInfo,
			closeMainDrawer,
			closeCartDrawer,
			customer,
			isMainDrawerOpen,
			isCartDrawerOpen,
			openStoreModal,
			toggleMainDrawer,
			toggleCartDrawer,
		} = this.props;

		const navbarProperties = {
			brandInfo,
			closeMainDrawer,
			closeCartDrawer,
			customer,
			isMainDrawerOpen,
			isCartDrawerOpen,
			logout: this.logout,
			toggleMainDrawer,
			toggleCartDrawer,
			closeLogin: this.closeLogin,
			openLogin: this.openLogin,
			openStoreModal,
			showLogin: this.state.showLogin,
			closeEmailCart: this.closeEmailCart,
			openEmailCart: this.openEmailCart,
			showEmailCart: this.state.showEmailCart,
			closeRegistration: this.closeRegistration,
			openRegistration: this.openRegistration,
			showRegistration: this.state.showRegistration,
			emailCartOpenLogin: this.emailCartOpenLogin,
		};

		return <NavBar {...navbarProperties} />;
	}
}

NavBarContainer.propTypes = {
	brandInfo: PropTypes.shape({
		logo: PropTypes.string,
		topics: PropTypes.arrayOf(PropTypes.object),
	}),
	closeMainDrawer: PropTypes.func.isRequired,
	closeCartDrawer: PropTypes.func.isRequired,
	customer: PropTypes.instanceOf(Customer).isRequired,
	getBrandInfo: PropTypes.func.isRequired,
	getGuestCustomer: PropTypes.func.isRequired,
	isMainDrawerOpen: PropTypes.bool,
	isCartDrawerOpen: PropTypes.bool,
	logout: PropTypes.func.isRequired,
	openStoreModal: PropTypes.func.isRequired,
	toggleMainDrawer: PropTypes.func.isRequired,
	toggleCartDrawer: PropTypes.func.isRequired,
	clearEmailCartMessages: PropTypes.func.isRequired,
};

NavBarContainer.defaultProps = {
	brandInfo: {
		logo: '',
		topics: [{}],
	},
	isMainDrawerOpen: false,
	isCartDrawerOpen: false,
};

// make state available via props
const mapStateToProps = state => {
	const brandInfo = state.brandInfo.get('brandInfo');
	const isMainDrawerOpen = state.navbar.get('isMainDrawerOpen');
	const isCartDrawerOpen = state.navbar.get('isCartDrawerOpen');
	const customer = state.user.get('customer');
	return {
		brandInfo,
		customer,
		isMainDrawerOpen,
		isCartDrawerOpen,
	};
};

// make actions from two domains available via props
const mapDispatchToProps = dispatch =>
	bindActionCreators(
		{
			...brandInfoActions,
			...navBarActions,
			...storeLocationActions,
			...userActions,
			...cartActions,
		},
		dispatch,
	);

// for testing purposes
export { NavBarContainer as NavBarContainerClass };

// connect returns a function that accepts a component
export default withRouter(compose(connect(mapStateToProps, mapDispatchToProps))(toJS(NavBarContainer)));
